export default __webpack_public_path__ + "static/Emma-54fe8b462268284f6c1f7d79e5c56aed.png";